module.exports = __webpack_public_path__ + "img/lideranca_bronze.f7075807.png";